import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUpdateAllProjectVariationsArgs,
  BackendProjectId,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateAllProjectVariations($projectId: ID!, $scoringMethod: ScoringMethodInput!) {
    updateAllProjectVariations(projectId: $projectId, scoringMethod: $scoringMethod) {
      id
    }
  }
`;

type Variables = BackendMutationUpdateAllProjectVariationsArgs;
type Result = BackendProjectId;

export const updateAllProjectVariations = async (
  variables: Variables,
  options?: GqlMutationOptions
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options,
  });
  return getSingleProp<Result>(result.data);
};
